import * as api from "@/api/williams/contractors";
import { queryKeys } from "../../queryKeys";
import { useQuery } from "react-query";

export function useContractorMetrics(id: string) {
  return useQuery({
    queryKey: queryKeys.contractor.metrics(id),
    queryFn: () => api.getContractorMetrics(id),
  });
}
